import { createRequiredContext } from '../../../libs/context'
import type { DockingView } from './dockableLayoutContext'

export type DockableModalContextType = {
  isDocked: boolean
  setDockingView: ((view: DockingView) => void) | undefined
}

const [useDockableModalContext, Provider] =
  createRequiredContext<DockableModalContextType>('DockableModal')

export { Provider, useDockableModalContext }
